import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Alert, Box } from '@mui/material';

interface Props {
  children: ReactNode;
  fallbackTitle?: string;
}

interface State {
  error: Error | null;
}

export default class MapErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Map render error:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <Box sx={{ my: 2 }}>
          <Alert severity="error">
            {this.props.fallbackTitle || 'Map failed to load'}: {this.state.error.message}
          </Alert>
        </Box>
      );
    }
    return this.props.children;
  }
}
